import { FunctionComponent, ReactNode } from 'react'
import {
	StyledOrderedList,
	StyledListItem,
	StyledListItemText,
} from './OrderedList.styled'

export interface OrderedListProps {
	compact?: boolean
	children: ReactNode
}

export interface ListItemProps {
	children: ReactNode
}

export interface ListItemTextProps {
	compact?: boolean
	children: ReactNode
}

export const OrderedList: FunctionComponent<OrderedListProps> = ({
	compact,
	children,
}) => {
	return <StyledOrderedList $compact={compact}>{children}</StyledOrderedList>
}

export const ListItem: FunctionComponent<ListItemProps> = ({ children }) => {
	return <StyledListItem>{children}</StyledListItem>
}

export const ListItemText: FunctionComponent<ListItemTextProps> = ({
	compact,
	children,
}) => {
	return <StyledListItemText $compact={compact}>{children}</StyledListItemText>
}
